"use strict";

var _classCallCheck = require("/builds/talea/fahrtwind/products/my-talea/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/builds/talea/fahrtwind/products/my-talea/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Router = void 0;

var logger_1 = require("./utils/logger");

var SYNC_DOCUMENT_NOTIFICATION_TYPE = 'com.twilio.rtd.cds.document';
var SYNC_LIST_NOTIFICATION_TYPE = 'com.twilio.rtd.cds.list';
var SYNC_MAP_NOTIFICATION_TYPE = 'com.twilio.rtd.cds.map';
var SYNC_NOTIFICATION_TYPE = 'twilio.sync.event';
/**
 * @class Router
 * @classdesc Routes all incoming messages to the consumers
 */

var Router = /*#__PURE__*/function () {
  function Router(params) {
    var _this = this;

    _classCallCheck(this, Router);

    this.config = params.config;
    this.subscriptions = params.subscriptions;
    this.notifications = params.notifications;
    this.notifications.subscribe(SYNC_NOTIFICATION_TYPE);
    this.notifications.subscribe(SYNC_DOCUMENT_NOTIFICATION_TYPE);
    this.notifications.subscribe(SYNC_LIST_NOTIFICATION_TYPE);
    this.notifications.subscribe(SYNC_MAP_NOTIFICATION_TYPE);
    this.notifications.on('message', function (messageType, payload) {
      return _this.onMessage(messageType, payload);
    });
    this.notifications.on('transportReady', function (isConnected) {
      return _this.onConnectionStateChanged(isConnected);
    });
  }
  /**
   * Entry point for all incoming messages
   * @param {String} type - Type of incoming message
   * @param {Object} message - Message to route
   */


  _createClass(Router, [{
    key: "onMessage",
    value: function onMessage(type, message) {
      logger_1.default.trace('Notification type:', type, 'content:', message);

      switch (type) {
        case SYNC_DOCUMENT_NOTIFICATION_TYPE:
        case SYNC_LIST_NOTIFICATION_TYPE:
        case SYNC_MAP_NOTIFICATION_TYPE:
          this.subscriptions.acceptMessage(message, false);
          break;

        case SYNC_NOTIFICATION_TYPE:
          this.subscriptions.acceptMessage(message, true);
          break;
      }
    }
    /**
     * Subscribe for events
     */

  }, {
    key: "subscribe",
    value: function subscribe(sid, entity) {
      this.subscriptions.add(sid, entity);
    }
    /**
     * Unsubscribe from events
     */

  }, {
    key: "unsubscribe",
    value: function unsubscribe(sid) {
      this.subscriptions.remove(sid);
    }
    /**
     * Handle transport establishing event
     * If we have any subscriptions - we should check object for modifications
     */

  }, {
    key: "onConnectionStateChanged",
    value: function onConnectionStateChanged(isConnected) {
      this.subscriptions.onConnectionStateChanged(isConnected);
    }
  }]);

  return Router;
}();

exports.Router = Router;
exports.default = Router;